import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';

import { useThreadAnswer } from '@ts-core/hooks/forum';

import AnswerForm from '@ts-core/components/Forum/AnswerForm';

const EditThreadAnswerPage = () => {
  const history = useHistory();
  const { courseId, threadId, answerId } = useParams();

  const onThreadAnswerUpdated = useCallback(() => {
    history.push(`/${courseId}/forum/${threadId}`);
  }, [history, courseId, threadId]);

  const {
    answer,
    onUpdateThreadAnswer,
    updatingThreadAnswer,
  } = useThreadAnswer({
    courseId,
    threadId,
    answerId,
    onThreadAnswerUpdated,
  });

  const handleGoBack = useCallback(() => {
    history.push(`/${courseId}/forum/${threadId}`);
  }, [history, courseId, threadId]);

  return (
    <>
      <BackButton
        title={
          <FormattedMessage
            id="forum.editAnswer"
            defaultMessage="Editar Respuesta"
          />
        }
        subtitle={<FormattedMessage id="forum.title" defaultMessage="Foro" />}
        onGoBack={handleGoBack}
      />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth={{ md: '100%', lg: 800 }}
        margin="auto"
      >
        {answer?._id && (
          <AnswerForm
            onSubmit={onUpdateThreadAnswer}
            submitting={updatingThreadAnswer}
            answer={answer}
          />
        )}
      </Box>
    </>
  );
};

export default EditThreadAnswerPage;
